import { Divider, Heading, Icon, Text, VStack } from "@chakra-ui/react";
import HoverableIconButton from "components/Atomos/Buttons/HoverableIconButton";
import { FiEdit } from "react-icons/fi";

type PostPopupProps = {
    header: string;
    title: string;
    address: string;
    hideButtons?: boolean;
    onEditClick?: () => void;
}

const PostPopup = ({
    address,
    header,
    title,
    hideButtons,
    onEditClick
}: PostPopupProps) => {
    return (
        <VStack p={2} justify="flex-start" align="flex-start">
            <Heading>{header}</Heading>
            <Text color="gray.300">{title}</Text>
            <Divider my={1} />
            <Text color="gray.300">Endereço: {address}</Text>
            {!hideButtons && (
                <HoverableIconButton
                    colorScheme="green"
                    icon={<Icon as={FiEdit} />}
                    label="Editar"
                    onClick={onEditClick}
                />
            )}
        </VStack>
    )
}
export default PostPopup